module.exports = __webpack_public_path__ + "assets/img/banner.5b0084c3.jpg";